import { render, staticRenderFns } from "./BlockVideo.vue?vue&type=template&id=126bade4&"
import script from "./BlockVideo.vue?vue&type=script&lang=js&"
export * from "./BlockVideo.vue?vue&type=script&lang=js&"
import style0 from "./BlockVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports